import router from '@/router'
import './style.scss'

export default {
  name: 'DrAgreement',
  props: {
    marginTop: {
      type: String,
      default: '0px'
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  render() {
    return (
      <div class='dr-agreement' style={{ marginTop: this.marginTop }}>
        <div class='paragraph'>
          <span class='checkbox'>
            <van-checkbox icon-size={10} value={this.value} onClick={() => { this.$emit('input', !this.value) }} shape='square' />
          </span>
          我已阅读并同意
          <span class='bookmarks' onClick={() => { router.push('UserAgreement') } }>《用户协议》</span>
          和
          <span class='bookmarks' onClick={() => { router.push('ServiceAgreement') } }>《隐私政策》</span>
        </div>
      </div>
    )
  }
}
